import {Component, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../../services/data.service';
import {CarrierApprovalService} from '../../services/carrier-approval/carrier-approval.service';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import AppConstants, {CarrierApprovalInfo} from '../../shared/common-components/AppConstants';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {TspAgyProfileAuditTrailComponent} from '../tspagy-profile-audit-trail/tspagy-profile-audit-trail.component';
import {OrganizationUpdateMessageComponent} from "../organization-update-message/organization-update-message.component";
import {OrganizationUpdateMessagesService} from "../../services/organization-update-messages/organization-update-messages.service";
import {CarrierProfileService} from "../../services/carrier-profile/carrier-profile.service";
import {ConfirmationModalComponent} from "../../shared/common-components/confirmation-modal/confirmation-modal.component";

@Component({
    selector: 'app-carrier-approval',
    templateUrl: './carrier-approval.component.html',
    styleUrls: ['./carrier-approval.component.css'],
    standalone: false
})

export class CarrierApprovalComponent implements OnInit {
  approvalType: any;
  carrierApprovalForm: UntypedFormGroup;
  carrierId: number;
  tpaId: string;
  tspCSI: string;
  appvedSlider = false;
  dateApproved: string;
  dateSuspended: string;
  approvalNotes: string;
  bondNum: string;
  bondExpDate: string;
  saveSuccessful = false;
  disabled = true;
  carrier: any = null;
  isFreightCarrier = false;
  isHhgCarrier = false;
  isBothCarrier = false;
  showSocio = false;
  showInsure = false;
  isInsuranceShortNamePresent = false;
  showCSI: boolean;
  csiValue: any;
  showBondInfo = false;
  invalidDate = false;
  minDate: Date;
  maxDate: Date;
  // bondReq: boolean = false;
  insureNameReqd: Boolean = false;
  insureReqd: Boolean = false;
  insureDateReqd: Boolean = false;
  datePickerConfig: Partial<BsDatepickerConfig>;
  checkbox: boolean;
  authorityTitle: string;
  authorityPlaceholder: string;
  defaultLoadBondDate: any;
  profileName: any;
  organizationId: any;
  updateProgram = 'TspApproval';
  bsModalRef: BsModalRef;
  messages: any;
  isReadOnly = false;
  enableRevokeBtn:Boolean = false;

  constructor(private carrierApprovalService: CarrierApprovalService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private dataService: DataService,
              private route: ActivatedRoute,
              private carrierProfileService: CarrierProfileService,
              private router: Router,
              private shipmentAuditTrailService: ShipmentAuditTrailService,
              private organizationmessagesservice: OrganizationUpdateMessagesService,
              private modalService: BsModalService) {
  }

  ngOnInit() {
    this.minDate = null;
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate());
    this.createForm();
    // this.disableFFAndMCAndUSDOTAndFMCOTI();
    this.route.queryParams.subscribe(params => {
      this.defaultLoadBondDate = params.carrierApprovalInformationEntity;
      if (params['carrierId']) {
        this.loadCarrierApprovalInfo(params);
        this.carrierApprovalForm.get('approvalNotes').setValidators([Validators.required]);
        this.carrierApprovalForm.updateValueAndValidity();
      } else {
        this.loadNewCarrierApprovalInfo(params);
        this.carrierApprovalForm.get('approvalNotes').clearValidators();
        this.carrierApprovalForm.updateValueAndValidity();
        this.disabled = false;
      }
      // this.profileName = params.scac + " - " + params.scacName;
      // this.organizationId = params.organizationEntity.organizationId;
      // this.areBothCheckboxesDisable();
    });

    this.carrierApprovalForm.valueChanges.subscribe(formData => {
      this.saveSuccessful = false;
    });
  }

  setValidationForinputMCNumber() {
    this.carrierApprovalForm.get('inputMCNumber').setValidators([Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
  }

  setValidationForinputFFNumber() {
    this.carrierApprovalForm.get('inputFFNumber').setValidators([Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
  }

  setValidationForFMCOTI() {
    this.carrierApprovalForm.get('fmcOTI').setValidators([Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
  }

  setValidationForDomesticUSDOT() {
    this.carrierApprovalForm.get('usDot').setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
  }

  setValidationForInternationalUSDOT() {
    this.carrierApprovalForm.get('usDot').setValidators([Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
  }

  setValueForUSDotMCNumberFFNumber(carrierApproval: any, approvalType: any) {
    this.carrierApprovalForm.get('inputMCNumber').enable();
    this.carrierApprovalForm.get('inputFFNumber').enable();
    this.carrierApprovalForm.get('usDot').enable();
    this.carrierApprovalForm.get('usDot').markAsUntouched();
    this.carrierApprovalForm.get('inputMCNumber').markAsUntouched();
    this.carrierApprovalForm.get('inputFFNumber').markAsUntouched();
    this.setValidationForinputMCNumber();
    this.setValidationForinputFFNumber();
    this.carrierApprovalForm.get('usDot').setValue((carrierApproval?.approvalType === approvalType) ? (carrierApproval?.usDotNumber ? carrierApproval?.usDotNumber : null) : null);
    this.carrierApprovalForm.get('inputMCNumber').setValue((carrierApproval?.approvalType === approvalType) ? (carrierApproval?.mcNumber ? carrierApproval?.mcNumber : null) : null);
    this.carrierApprovalForm.get('inputFFNumber').setValue((carrierApproval?.approvalType === approvalType) ? (carrierApproval?.ffNumber ? carrierApproval?.ffNumber : null) : null);
    if (approvalType === 'International HHG') {
      this.carrierApprovalForm.get('fmcOTI').enable();
      this.carrierApprovalForm.get('fmcOTI').markAsUntouched();
      this.setValidationForFMCOTI();
      this.setValidationForInternationalUSDOT();
      this.carrierApprovalForm.get('fmcOTI').setValue(carrierApproval.fmcOtiNumber ? carrierApproval.fmcOtiNumber : null);
    } else {
      this.setValidationForDomesticUSDOT();
      this.carrierApprovalForm.get('fmcOTI').disable();
    }
    if (approvalType === 'Domestic HHG') {
      this.carrierApprovalForm.get('intraStateScope').setValue(carrierApproval.intraStateScope ? carrierApproval.intraStateScope : 0);
    }
  }

  setValuesForFFNumberAndMCNumber() {
    if (this.approvalType === 'Domestic HHG' || this.approvalType === 'International HHG') {
      this.carrierApprovalForm.get('inputFFNumber').setValue(this.carrierApprovalForm.value.inputFFNumber ? this.carrierApprovalForm.value.inputFFNumber : null);
      this.carrierApprovalForm.get('inputMCNumber').setValue(this.carrierApprovalForm.value.inputMCNumber ? this.carrierApprovalForm.value.inputMCNumber : null);
    }
  }

  activateUSDotValidation(selectedApprovalType: any) {
    if (selectedApprovalType === 'Domestic HHG' || selectedApprovalType === 'International HHG') {
      this.carrierApprovalForm.get('usDot').enable();
      this.carrierApprovalForm.get('fmcOTI').enable();
      if (selectedApprovalType === 'International HHG') {
        this.carrierApprovalForm.get('fmcOTI').setValidators([Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
        this.carrierApprovalForm.get('usDot').setValidators([Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
      } else {
        this.carrierApprovalForm.get('fmcOTI').disable();
        this.carrierApprovalForm.get('usDot').setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(12), Validators.pattern('^[0-9]*$')]);
      }
    } else {
      this.carrierApprovalForm.get('usDot').disable();
      this.carrierApprovalForm.get('fmcOTI').disable();
      this.carrierApprovalForm.get('fmcOTI').clearValidators();
      this.carrierApprovalForm.get('usDot').clearValidators();
    }
    this.carrierApprovalForm.get('usDot').updateValueAndValidity();
    this.carrierApprovalForm.get('fmcOTI').updateValueAndValidity();
  }

  createForm() {
    this.carrierApprovalForm = this.fb.group({
      approvalType: [null],
      tpaId: [null, [Validators.required]],
      tspCSI: [null],
      appvedSlider: [null, {disabled: true}],
      dateApproved: [null, [Validators.required]],
      dateSuspended: [null],
      approvalNotes: [null],
      bondNum: [null],
      bondExpDate: [null],
      insurExpDate: [null],
      insurName: [null],
      insurNum: [null],
      smallBiz: [null],
      otherThanSmallBiz: [null],
      womenBiz: [null],
      veteranBiz: [null],
      disabledVetBiz: [null],
      sbaBiz: [null],
      firm8a: [null],
      hubZone: [null],
      usDot: [null],
      inputMCNumber: [null],
      inputFFNumber: [null],
      fmcOTI: [null],
      intraStateScope: [null]
    }, {
      validator: this.validateForInternationalHHGAndDomesticHHG
    });
    this.carrierApprovalForm.controls['appvedSlider'].disable();
  }

  onIntraStateScope(e: any) {
    console.log(this.carrierApprovalForm.get('intraStateScope'));
    //
  }

  validateForInternationalHHGAndDomesticHHG(group: UntypedFormGroup) {
    if (group.controls['approvalType'].value === 'International HHG') {
      if (AppConstants.isNotNullCondition(group.controls['fmcOTI'].value)
        || ((AppConstants.isNotNullCondition(group.controls['inputMCNumber'].value)))
        || ((AppConstants.isNotNullCondition(group.controls['inputFFNumber'].value)))) {
        return null;
      } else {
        return {oneOfThreeHasValue: true};
      }
    } else if (group.controls['approvalType'].value === 'Domestic HHG') {
      if (group.controls['intraStateScope'].value === true) { return null; }
      if (((AppConstants.isNotNullCondition(group.controls['inputMCNumber'].value)))
        || ((AppConstants.isNotNullCondition(group.controls['inputFFNumber'].value)))) {
        return null;
      } else {
        return {oneOfTwoHasValue: true};
      }
    }
  }

  disableFFAndMCAndUSDOTAndFMCOTI() {
    this.carrierApprovalForm.get('inputMCNumber').disable();
    this.carrierApprovalForm.get('inputFFNumber').disable();
    this.carrierApprovalForm.get('usDot').disable();
    this.carrierApprovalForm.get('fmcOTI').disable();
  }

  // to turn on and off the Approved slider based on dates
  changeSlider($e, dateType) {
    this.invalidDate = false;
    if (dateType === 'approved') {
      const dateApproved = $e;
      const dateSuspended = this.carrierApprovalForm.value.dateSuspended;
      this.validateDateApprovedSuspended(dateApproved, AppConstants.isNotNullCondition(dateSuspended) ? new Date(dateSuspended) : null);
      if (AppConstants.isNotNullCondition(dateApproved) && (dateSuspended === null || dateSuspended === undefined || dateSuspended === '')) {
        this.carrierApprovalForm.get('appvedSlider').setValue(true);
      } else if (AppConstants.isNotNullCondition(dateApproved) && AppConstants.isNotNullCondition(dateSuspended)) {
        this.carrierApprovalForm.get('appvedSlider').setValue(false);
      } else {
        this.carrierApprovalForm.get('appvedSlider').setValue(false);
      }
    }
    if (dateType === 'suspended') {
      const dateSuspended = $e;
      const dateApproved = this.carrierApprovalForm.value.dateApproved;
      this.validateDateApprovedSuspended(AppConstants.isNotNullCondition(dateApproved) ? new Date(dateApproved) : null, dateSuspended);
      if (AppConstants.isNotNullCondition(dateApproved) && (dateSuspended === null || dateSuspended === undefined || dateSuspended === '')) {
        this.carrierApprovalForm.get('appvedSlider').setValue(true);
      } else if (AppConstants.isNotNullCondition(dateApproved) && AppConstants.isNotNullCondition(dateSuspended)) {
        this.carrierApprovalForm.get('appvedSlider').setValue(false);
      } else {
        this.carrierApprovalForm.get('appvedSlider').setValue(false);
      }
    }
  }

  /**
   * @description checks whether approved data is less than suspended date, if not checks the invalid flag.
   */
  validateDateApprovedSuspended(approvedDate, suspendedDate) {
    if (AppConstants.isNotNullCondition(approvedDate) && AppConstants.isNotNullCondition(suspendedDate)) {
      if (((new Date(approvedDate.setHours(0, 0, 0, 0)))).getTime() > ((new Date(suspendedDate.setHours(0, 0, 0, 0)))).getTime()) {
        this.invalidDate = true;
      } else {
        this.invalidDate = false;
      }
    }
  }

  validateBondInfo() {
    // this.bondReq = false;
    if (AppConstants.isNotNullCondition(this.carrierApprovalForm.value.bondNum)) {
      if (!AppConstants.isNotNullCondition(this.carrierApprovalForm.value.bondExpDate)) {
        // this.bondReq = true;
      }
      this.carrierApprovalForm.get('bondExpDate').setValidators([Validators.required]);
    } else {
      // this.bondReq = false;
      this.carrierApprovalForm.get('bondExpDate').setValue(null);
      this.carrierApprovalForm.get('bondExpDate').clearValidators();
    }
  }

  // validateBondInfo1($event) {
  //   if (AppConstants.isNotNullCondition(this.carrierApprovalForm.value.bondNum) && !AppConstants.isNotNullCondition($event)) {
  //     this.bondReq = true;
  //   } else {
  //     this.bondReq = false;
  //   }
  // }

  validateInsureInfo() {
    if ((this.carrierApprovalForm.value.insurName !== '') && (this.carrierApprovalForm.value.insurNum === null || this.carrierApprovalForm.value.insurNum === '')) {
      this.insureReqd = true;
      this.carrierApprovalForm.get('insurExpDate').setValue(null);
    } else {
      this.insureReqd = false;
    }
    if (this.carrierApprovalForm.value.insurName === '') {
      this.carrierApprovalForm.get('insurNum').setValue(null);
      this.carrierApprovalForm.get('insurExpDate').setValue(null);
      this.insureDateReqd = false;
    } else {
      this.insureDateReqd = true;
    }
  }

  validateInsureInfo1() {
    if (this.carrierApprovalForm.value.insurNum === '' && this.carrierApprovalForm.value.insurNum === null) {
      this.carrierApprovalForm.get('insurExpDate').setValue(null);
    }
  }

  onInsuranceShortNameChange() {
    const insuranceShortName = this.carrierApprovalForm.value.insurName;
    if (AppConstants.isNotNullCondition(insuranceShortName)) {
      this.isInsuranceShortNamePresent = true;
      this.carrierApprovalForm.get('insurExpDate').setValidators([Validators.required]);
      this.carrierApprovalForm.get('insurNum').setValidators([Validators.required]);
    } else {
      this.isInsuranceShortNamePresent = false;
      this.carrierApprovalForm.get('insurExpDate').setValidators(null);
      this.carrierApprovalForm.get('insurExpDate').setErrors(null);
      this.carrierApprovalForm.get('insurNum').setValidators(null);
      this.carrierApprovalForm.get('insurNum').setErrors(null);
    }
  }

  validateInsuranceInformation(type: string) {
    this.insureNameReqd = false;
    this.insureDateReqd = false;
    this.insureReqd = false;
    switch (type) {
      case 'insuranceName' :
        if (AppConstants.isNotNullCondition(this.carrierApprovalForm.value.insurName)) {
          this.carrierApprovalForm.get('insurNum').setValue(null);
          this.carrierApprovalForm.get('insurExpDate').setValue(null);
          this.insureDateReqd = true;
          this.insureReqd = true;
        } else {
          this.insureDateReqd = false;
          this.insureReqd = false;
        }
        break;
      case 'insuranceNumber' :
        if (AppConstants.isNotNullCondition(this.carrierApprovalForm.value.insurNum)) {
          this.carrierApprovalForm.get('insurExpDate').setValue(null);
          this.carrierApprovalForm.get('insurName').setValue(null);
          this.insureNameReqd = true;
          this.insureDateReqd = true;
        } else {
          this.insureNameReqd = false;
          this.insureDateReqd = false;
        }
        break;
      case 'insuranceExpirationDate' :
        if (AppConstants.isNotNullCondition(this.carrierApprovalForm.value.insurExpDate)) {
          this.carrierApprovalForm.get('insurName').setValue(null);
          this.carrierApprovalForm.get('insurNum').setValue(null);
          this.insureNameReqd = true;
          this.insureReqd = true;
        } else {
          this.insureNameReqd = false;
          this.insureReqd = false;
        }
        break;
      default:
        this.carrierApprovalForm.get('insurName').setValue(null);
        this.carrierApprovalForm.get('insurNum').setValue(null);
        this.carrierApprovalForm.get('insurExpDate').setValue(null);
        this.insureNameReqd = false;
        this.insureDateReqd = false;
        this.insureReqd = false;
        break;
    }
  }

  // load a new carrier approval info
  loadNewCarrierApprovalInfo(params) {
    this.carrierId = params['carrierId'];
  }

  // load existing carrier approval info
  loadCarrierApprovalInfo(params) {
    this.loader.show();
    this.enableRevokeBtn = false;
    this.carrierApprovalService.getCarrier(params['carrierId']).subscribe(carrier => {
      this.carrierApprovalService.carrier.next(carrier);
      this.carrier = carrier;
      this.showSocio = true;
      this.organizationId = carrier.organizationEntity.organizationId;
      this.profileName = carrier.scac + ' - ' + carrier.scacName;
      if (this.carrier.businessType === 'HHG') {
        this.isHhgCarrier = true;
        this.showBondInfo = true;
        this.carrierApprovalForm.get('approvalType').setValue('Domestic HHG');
      } else if (this.carrier.businessType === 'FRT') {
        this.isFreightCarrier = true;
        this.showInsure = true;
        this.carrierApprovalForm.get('approvalType').setValue('Domestic FRT');
      } else {
        this.isBothCarrier = true;
        this.showBondInfo = true;
        this.carrierApprovalForm.get('approvalType').setValue('Domestic HHG');
      }
      this.loader.hide();
    }, (error) => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Carrier Approval Info');
    }, () => {
      // this.approvalType = this.carrier.carrierApprovalInformationEntity[0].approvalType;
      this.approvalType = CarrierApprovalInfo.DOMESTICHHG;
      for (const carrierApproval of this.carrier.carrierApprovalInformationEntity) {
        if (carrierApproval.approvalType === 'Domestic HHG' || carrierApproval.approvalType === 'International HHG') {
          this.showCSI = true;
          if (carrierApproval.approvalType === CarrierApprovalInfo.DOMESTICHHG) {
            this.setValueForUSDotMCNumberFFNumber(carrierApproval, this.approvalType);
          }
        } else {
          this.showCSI = false;
        }
        if ((this.carrier.businessType === 'HHG' || this.carrier.businessType === 'FRT' || this.carrier.businessType === 'HHG & FRT') &&
          (carrierApproval.approvalType === 'Domestic HHG' || carrierApproval.approvalType === 'Domestic FRT')) {
          this.carrierApprovalForm.get('tpaId').setValue(carrierApproval.tpaNumber);
          this.carrierApprovalForm.get('tspCSI').setValue(carrierApproval.customerSatisfactionIndex);
          this.carrierApprovalForm.get('dateApproved').setValue(AppConstants.isNotNullCondition(carrierApproval.approvalDate) ? new Date(carrierApproval.approvalDate) : '');
          this.carrierApprovalForm.get('dateSuspended').setValue(AppConstants.isNotNullCondition(carrierApproval.suspendedDate) ? new Date(carrierApproval.suspendedDate) : '');

          if (carrierApproval.revoked){
            this.isReadOnly = true;
            this.enableRevokeBtn = false;
          } else {
            this.isReadOnly = false;
            this.enableRevokeBtn = true;
          }

          if (carrierApproval.approvalDate !== null) {
            this.carrierApprovalForm.get('appvedSlider').setValue(true);
          }
          if (carrierApproval.suspendedDate !== null) {
            this.carrierApprovalForm.get('appvedSlider').setValue(false);
          }
          this.carrierApprovalForm.get('approvalNotes').setValue(carrierApproval.approvalNotes);
          this.carrierApprovalForm.get('bondNum').setValue(carrierApproval.bondIdentifier);
          this.carrierApprovalForm.get('bondExpDate').setValue(AppConstants.isNotNullCondition(carrierApproval.bondDate) ? new Date(carrierApproval.bondDate) : '');
          this.carrierApprovalForm.get('insurName').setValue(carrierApproval.insuranceShortName);
          this.carrierApprovalForm.get('insurNum').setValue(carrierApproval.insuranceIdentifier);
          this.carrierApprovalForm.get('insurExpDate').setValue(carrierApproval.insuranceExpiryDate);
          if (this.isReadOnly) {
            this.disableForm();
          } else {
            this.enableForm();
          }
          // break;
        }
      }

      for (const carrierSocioEconomic of this.carrier.carrierToSocioeconomicIndicatorEntity) {
        switch (carrierSocioEconomic.scacEconomicIndicator) {
          case 1:
            this.carrierApprovalForm.get('smallBiz').setValue(true);
            break;
          case 2:
            this.carrierApprovalForm.get('otherThanSmallBiz').setValue(true);
            break;
          case 3:
            this.carrierApprovalForm.get('womenBiz').setValue(true);
            break;
          case 4:
            this.carrierApprovalForm.get('veteranBiz').setValue(true);
            break;
          case 5:
            this.carrierApprovalForm.get('disabledVetBiz').setValue(true);
            break;
          case 6:
            this.carrierApprovalForm.get('sbaBiz').setValue(true);
            break;
          case 7:
            this.carrierApprovalForm.get('firm8a').setValue(true);
            break;
          case 8:
            this.carrierApprovalForm.get('hubZone').setValue(true);
            break;
        }
      }
      this.activateUSDotValidation(this.carrierApprovalForm.get('approvalType').value);
      this.approvalType = this.carrierApprovalForm.get('approvalType').value;
      this.loader.hide();
    });
  }

  // update carrier approval data
  saveCarrierApproval() {
    const carrierApprovalForm = this.carrierApprovalForm;
    if (this.carrier === null) {
      this.carrier = {};
    }
    this.carrier.changedApprovalType = carrierApprovalForm.value.approvalType;
    // for form approval updates
    let newApproval = true;
    let i = 0;
    for (const carrierApproval of this.carrier.carrierApprovalInformationEntity) {
      if (this.carrier.changedApprovalType === carrierApproval.approvalType) {
        this.carrier.prevSuspendedStatus = this.carrier.carrierApprovalInformationEntity[i].suspended;
        this.carrier.carrierApprovalInformationEntity[i].carrierId = this.carrier.carrierId;
        this.carrier.carrierApprovalInformationEntity[i].tpaNumber = carrierApprovalForm.value.tpaId;
        this.carrier.carrierApprovalInformationEntity[i].customerSatisfactionIndex = carrierApprovalForm.value.tspCSI;
        this.carrier.carrierApprovalInformationEntity[i].approvalDate = AppConstants.isNotNullCondition((carrierApprovalForm.value.dateApproved)) ? new Date(carrierApprovalForm.value.dateApproved) : '';
        this.carrier.carrierApprovalInformationEntity[i].suspendedDate = AppConstants.isNotNullCondition((carrierApprovalForm.value.dateSuspended)) ? new Date(carrierApprovalForm.value.dateSuspended) : '';
        if (AppConstants.isNotNullCondition(carrierApprovalForm.value.dateSuspended)) {
          this.carrier.carrierApprovalInformationEntity[i].suspended = 1;
        } else {
          this.carrier.carrierApprovalInformationEntity[i].suspended = 0;
        }
        this.carrier.carrierApprovalInformationEntity[i].approvalNotes = carrierApprovalForm.value.approvalNotes;
        this.carrier.carrierApprovalInformationEntity[i].bondIdentifier = carrierApprovalForm.value.bondNum;
        this.carrier.carrierApprovalInformationEntity[i].bondDate = AppConstants.isNotNullCondition((carrierApprovalForm.value.bondExpDate)) ? new Date(carrierApprovalForm.value.bondExpDate) : '';
        this.carrier.carrierApprovalInformationEntity[i].insuranceShortName = carrierApprovalForm.value.insurName;
        this.carrier.carrierApprovalInformationEntity[i].insuranceIdentifier = carrierApprovalForm.value.insurNum;
        this.carrier.carrierApprovalInformationEntity[i].insuranceExpiryDate = carrierApprovalForm.value.insurExpDate;
        this.carrier.carrierApprovalInformationEntity[i].mcNumber = ((this.approvalType === 'Domestic HHG') || (this.approvalType === 'International HHG')) ? (carrierApprovalForm.value.inputMCNumber) : null;
        this.carrier.carrierApprovalInformationEntity[i].ffNumber = ((this.approvalType === 'Domestic HHG') || (this.approvalType === 'International HHG')) ? (carrierApprovalForm.value.inputFFNumber) : null;
        this.carrier.carrierApprovalInformationEntity[i].usDotNumber = ((this.approvalType === 'Domestic HHG') || (this.approvalType === 'International HHG')) ? carrierApprovalForm.value.usDot : null;
        this.carrier.carrierApprovalInformationEntity[i].fmcOtiNumber = (this.approvalType === 'International HHG') ? carrierApprovalForm.value.fmcOTI : null;
        this.carrier.carrierApprovalInformationEntity[i].intraStateScope = (this.approvalType === 'Domestic HHG') ? ((carrierApprovalForm.value.intraStateScope) ? 1 : 0) : 0;
        newApproval = false;
        break;
      }
      i++;
    }
    this.setValuesForFFNumberAndMCNumber();
    if (newApproval) {
      const carrApp = {};
      carrApp['carrierId'] = this.carrier.carrierId;
      carrApp['tpaNumber'] = carrierApprovalForm.value.tpaId;
      carrApp['approvalType'] = this.carrier.changedApprovalType;
      carrApp['customerSatisfactionIndex'] = carrierApprovalForm.value.tspCSI;
      carrApp['approvalDate'] = carrierApprovalForm.value.dateApproved;
      if (carrierApprovalForm.value.dateApproved !== null) {
        carrApp['suspended'] = 0;
      }
      if (carrierApprovalForm.value.dateSuspended !== null) {
        carrApp['suspended'] = 1;
      }
      carrApp['suspendedDate'] = carrierApprovalForm.value.dateSuspended;
      carrApp['approvalNotes'] = carrierApprovalForm.value.approvalNotes;
      carrApp['bondIdentifier'] = carrierApprovalForm.value.bondNum;
      carrApp['bondDate'] = carrierApprovalForm.value.bondExpDate;
      carrApp['insuranceShortName'] = carrierApprovalForm.value.insurName;
      carrApp['insuranceIdentifier'] = carrierApprovalForm.value.insurNum;
      carrApp['insuranceExpiryDate'] = carrierApprovalForm.value.insurExpDate;
      carrApp['mcNumber'] = ((this.approvalType === 'Domestic HHG') || (this.approvalType === 'International HHG')) ? (carrierApprovalForm.value.inputMCNumber) : null;
      carrApp['ffNumber'] = ((this.approvalType === 'Domestic HHG') || (this.approvalType === 'International HHG')) ? (carrierApprovalForm.value.inputFFNumber) : null;
      carrApp['usDotNumber'] = ((this.approvalType === 'Domestic HHG') || (this.approvalType === 'International HHG')) ? carrierApprovalForm.value.usDot : null;
      carrApp['fmcOtiNumber'] = (this.approvalType === 'International HHG') ? carrierApprovalForm.value.fmcOTI : null;
      carrApp['intraStateScope'] = ((this.approvalType === 'Domestic HHG')) ? (carrierApprovalForm.value.intraStateScope) : 0;
      carrApp['revoked'] = 0;
      this.carrier.carrierApprovalInformationEntity.push(carrApp);
    }

    // this.carrier.carrierToSocioeconomicIndicatorEntity.push (sci);
    // set socioeconomic array with selected check boxes
    this.carrier.carrierToSocioeconomicIndicatorEntity = [];
    if (this.carrierApprovalForm.get('smallBiz').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 1;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    if (this.carrierApprovalForm.get('otherThanSmallBiz').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 2;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    if (this.carrierApprovalForm.get('womenBiz').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 3;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    if (this.carrierApprovalForm.get('veteranBiz').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 4;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    if (this.carrierApprovalForm.get('disabledVetBiz').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 5;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    if (this.carrierApprovalForm.get('sbaBiz').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 6;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    if (this.carrierApprovalForm.get('firm8a').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 7;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    if (this.carrierApprovalForm.get('hubZone').value === true) {
      const sci = {};
      sci['carrierId'] = this.carrier.carrierId;
      sci['scacEconomicIndicator'] = 8;
      this.carrier.carrierToSocioeconomicIndicatorEntity.push(sci);
    }
    this.loader.show();
    this.carrierApprovalService.updateCarrier(this.carrier).subscribe(carrier => {
        this.carrier = carrier;
        this.alertService.success('Successfully Updated the carrier approval');
        window.scrollTo(0, 0);
        this.enableRevokeBtn = true;
        this.saveSuccessful = true;
        this.loader.hide();
      },
      error => {
        this.enableRevokeBtn = false;
        this.loader.hide();
        this.alertService.error('Error in updating carrier approval' + error);
      });
  }

  onFocusBondDate(e: any) {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() - 1);
  }

  onFocusOutBondDate(e: any) {
    this.minDate = null;
  }

  // to change approvalType from the list
  changeApprovalType($event) {
    const selectedValue = $event.target.value;
    this.isReadOnly = false;
    this.enableRevokeBtn = false;
    this.approvalType = this.carrierApprovalForm.get('approvalType').value;
    this.carrierApprovalForm.get('tpaId').setValue(null);
    this.carrierApprovalForm.get('tspCSI').setValue('0');
    this.carrierApprovalForm.get('dateApproved').setValue(null);
    this.carrierApprovalForm.get('dateSuspended').setValue(null);
    this.carrierApprovalForm.get('approvalNotes').setValue(null);
    this.carrierApprovalForm.get('appvedSlider').setValue(false);
    this.carrierApprovalForm.get('bondNum').setValue(null);
    this.carrierApprovalForm.get('bondExpDate').setValue('');
    this.carrierApprovalForm.get('insurName').setValue(null);
    this.carrierApprovalForm.get('insurNum').setValue(null);
    this.carrierApprovalForm.get('insurExpDate').setValue(null);
    this.showSocio = this.approvalType === 'Domestic HHG' || this.approvalType === 'Domestic FRT';
    if (this.approvalType === 'Domestic FRT' || this.approvalType === 'Freight Forwarder' ||
      this.approvalType === 'Freight Broker' || this.approvalType === 'Freight Shipper Agent' ||
      this.approvalType === 'Freight Rate Filing Service') {
      this.showInsure = true;
      this.showBondInfo = false;
    } else {
      this.showInsure = false;
      this.showBondInfo = true;
    }
    for (const carrierApproval of this.carrier.carrierApprovalInformationEntity) {
      if (this.approvalType === 'Domestic HHG' || this.approvalType === 'International HHG') {
        this.setValueForUSDotMCNumberFFNumber(carrierApproval, this.approvalType);
        this.showCSI = true;
      } else {
        this.showCSI = false;
        this.disableFFAndMCAndUSDOTAndFMCOTI();
      }
      if (this.approvalType === carrierApproval.approvalType) {
        this.carrierApprovalForm.get('tpaId').setValue(carrierApproval.tpaNumber);
        this.carrierApprovalForm.get('tspCSI').setValue(carrierApproval.customerSatisfactionIndex);
        this.carrierApprovalForm.get('dateApproved').setValue(AppConstants.isNotNullCondition(carrierApproval.approvalDate) ? new Date(carrierApproval.approvalDate) : '');
        this.carrierApprovalForm.get('dateSuspended').setValue(AppConstants.isNotNullCondition(carrierApproval.suspendedDate) ? new Date(carrierApproval.suspendedDate) : '');
        if (carrierApproval.approvalDate !== null) {
          this.carrierApprovalForm.get('appvedSlider').setValue(true);
        }
        if (carrierApproval.suspendedDate !== null) {
          this.carrierApprovalForm.get('appvedSlider').setValue(false);
        }
        if (carrierApproval.revoked){
          this.isReadOnly = true;
          this.enableRevokeBtn = false;
        } else {
          this.isReadOnly = false;
          this.enableRevokeBtn = true;
        }
        this.carrierApprovalForm.get('approvalNotes').setValue(carrierApproval.approvalNotes);
        this.carrierApprovalForm.get('bondNum').setValue(carrierApproval.bondIdentifier);
        this.carrierApprovalForm.get('bondExpDate').setValue(AppConstants.isNotNullCondition(carrierApproval.bondDate) ? new Date(carrierApproval.bondDate) : '');
        this.carrierApprovalForm.get('insurName').setValue(carrierApproval.insuranceShortName);
        this.carrierApprovalForm.get('insurNum').setValue(carrierApproval.insuranceIdentifier);
        this.carrierApprovalForm.get('insurExpDate').setValue(carrierApproval.insuranceExpiryDate);
        if (this.isReadOnly) {
          this.disableForm();
        } else {
          this.enableForm();
        }
        // if readonly is true then this.carrierApprovalForm.disabled
        break;
      }
    }
    this.activateUSDotValidation(this.approvalType);
  }

  viewAuditTrial() {
    this.loader.show();
    if (AppConstants.isNotNullCondition(this.organizationId) && AppConstants.isNotNullCondition(this.updateProgram)) {
      this.shipmentAuditTrailService.getAuditTrailListByOrgIdAndUpdateProgram(this.organizationId, this.updateProgram).subscribe(data => {
        if (data) {
          const initialState: any = {
            auditTrailLogList: data,
            profile: this.profileName
          };
          this.bsModalRef = this.modalService.show(TspAgyProfileAuditTrailComponent, {initialState, backdrop: 'static', class: 'modal-xl'});
        } else {
          this.alertService.error('No Audit Trail to display.');
        }
        this.loader.hide();
      }, (error) => {
        console.log('There was an error retrieving auditTrailLog records');
        this.loader.hide();
        this.alertService.error('There was an error retrieving auditTrailLog records');
      });
    }
  }

  /**
   * @description goes to carrier profile with appropriate queryParams when user clicked on user list
   */
  gotToCarrierProfile() {
    this.router.navigate(['/carrierprofile'], {
      queryParams: {orgId: [this.carrier.organizationId]}
    });
  }

  messageHistoryModal() {
    this.loader.show();
    this.organizationmessagesservice.getApprovalMessages(this.organizationId, 'TspProfileApprovalUpdate').subscribe(messages => {
      this.messages = messages;
      if (this.messages.length > 0) {
        const initialState = {
          messages: this.messages,
          profile: this.profileName,
          header: 'Approval Update Notes History'
        };
        this.bsModalRef = this.modalService.show(OrganizationUpdateMessageComponent, { initialState, backdrop: 'static', class: 'modal-lg' });
      } else {
        this.alertService.error('No messages/notes history to display.');
      }

      this.loader.hide();
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Unable to load the message history.. Please try again later or contact system administrator');
    });
  }

  /**
   * @description goes to HHG scope with appropriate queryParams when user clicked on user list
   */
  goToHHgScope() {
    this.router.navigate(['/hhgscope'], {
      queryParams: {carrierId: this.carrier.carrierId}
    });
  }

  get inputMCNumber() {
    return this.carrierApprovalForm.get('inputMCNumber');
  }

  get inputFFNumber() {
    return this.carrierApprovalForm.get('inputFFNumber');
  }

  get usDot() {
    return this.carrierApprovalForm.get('usDot');
  }

  get fmcOTI() {
    return this.carrierApprovalForm.get('fmcOTI');
  }

  // to deactivate a TSP
  deleteCarrierData() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = `Are you sure you want to proceed with Revoking this TSP’s ` + this.carrierApprovalForm.get('approvalType').value + ` Approval?`,
      this.bsModalRef.content.title = 'Revoke TSP Approval';
    this.bsModalRef.content.confirmText = 'YES';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.revokeApproval();
      }
    }, () => {
      this.alertService.warn('Revoking TSP has been cancelled.');
    });
  }

  revokeApproval() {
    this.loader.show(); // deleteOrganization
    const deleteCarrierMappingEntity: any = {
      'orgId': this.organizationId,
      'carrierId': this.carrier.carrierId,
      'approvalType': this.approvalType,
      'message': this.carrierApprovalForm.get('approvalNotes').value
    };
    this.carrierApprovalService.deleteCarrierApprovalWithMessage(deleteCarrierMappingEntity).subscribe(deleted => {
      // this.deleted = deleted;
      this.alertService.success('Successfully Revoked the selected TSP Approval Type');
      // agencyCode + '' + bureauCode + '-' + agencyBureauName + '<br />' + ' Location: ' + city + '-' + stateCountryCode
      //this.router.navigate(['/agencytspsearch']);
      this.isReadOnly = true;
      this.disableForm();
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('Error while revoking TSP approval');
    });
  }

  reinstateApproval() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'Do you want to proceed with the reinstation of this approval type',
      this.bsModalRef.content.title = 'Reinstate TSP Approval';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show(); // deleteOrganization
        const deleteCarrierMappingEntity: any = {
          'orgId': this.organizationId,
          'carrierId': this.carrier.carrierId,
          'approvalType': this.approvalType,
          'message': this.carrierApprovalForm.get('approvalNotes').value
        };

        this.carrierApprovalService.reinstateCarrierApprovalWithMessage(deleteCarrierMappingEntity).subscribe(deleted => {
          // this.deleted = deleted;
          this.enableForm();
          this.isReadOnly = false;
          this.alertService.success('Successfully Reinstated the selected TSP Approval Type');
          // agencyCode + '' + bureauCode + '-' + agencyBureauName + '<br />' + ' Location: ' + city + '-' + stateCountryCode
          //this.router.navigate(['/agencytspsearch']);
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('Error while reinstating TSP approval');
        });
      }
    }, () => {
      this.alertService.warn('Reinstate TSP approval type has been cancelled.');
    });

  }

  disableForm() {
    this.carrierApprovalForm.get('inputMCNumber').disable();
    this.carrierApprovalForm.get('inputFFNumber').disable();
    this.carrierApprovalForm.get('usDot').disable();
    this.carrierApprovalForm.get('fmcOTI').disable();
    this.carrierApprovalForm.get('intraStateScope').disable();
    this.carrierApprovalForm.get('tpaId').disable();
    this.carrierApprovalForm.get('dateApproved').disable();
    this.carrierApprovalForm.get('dateSuspended').disable();
    this.carrierApprovalForm.get('bondNum').disable();
    this.carrierApprovalForm.get('bondExpDate').disable();
    this.carrierApprovalForm.get('insurExpDate').disable();
    this.carrierApprovalForm.get('insurName').disable();
    this.carrierApprovalForm.get('insurNum').disable();
    this.carrierApprovalForm.get('smallBiz').disable();
    this.carrierApprovalForm.get('otherThanSmallBiz').disable();
    this.carrierApprovalForm.get('womenBiz').disable();
    this.carrierApprovalForm.get('veteranBiz').disable();
    this.carrierApprovalForm.get('disabledVetBiz').disable();
    this.carrierApprovalForm.get('sbaBiz').disable();
    this.carrierApprovalForm.get('firm8a').disable();
    this.carrierApprovalForm.get('hubZone').disable();
    this.carrierApprovalForm.get('approvalNotes').setValue('');
  }

  enableForm() {
    this.carrierApprovalForm.get('inputMCNumber').enable();
    this.carrierApprovalForm.get('inputFFNumber').enable();
    this.carrierApprovalForm.get('usDot').enable();
    this.carrierApprovalForm.get('fmcOTI').enable();
    this.carrierApprovalForm.get('intraStateScope').enable();
    this.carrierApprovalForm.get('tpaId').enable();
    this.carrierApprovalForm.get('dateApproved').enable();
    this.carrierApprovalForm.get('dateSuspended').enable();
    this.carrierApprovalForm.get('bondNum').enable();
    this.carrierApprovalForm.get('bondExpDate').enable();
    this.carrierApprovalForm.get('insurExpDate').enable();
    this.carrierApprovalForm.get('insurName').enable();
    this.carrierApprovalForm.get('insurNum').enable();
    this.carrierApprovalForm.get('smallBiz').enable();
    this.carrierApprovalForm.get('otherThanSmallBiz').enable();
    this.carrierApprovalForm.get('womenBiz').enable();
    this.carrierApprovalForm.get('veteranBiz').enable();
    this.carrierApprovalForm.get('disabledVetBiz').enable();
    this.carrierApprovalForm.get('sbaBiz').enable();
    this.carrierApprovalForm.get('firm8a').enable();
    this.carrierApprovalForm.get('hubZone').enable();
    this.carrierApprovalForm.get('approvalNotes').setValue('');
  }

}
